import './company.scss';
import * as React from 'react';
import { ProductsWrapper } from '../../components/aboutUs/products';
import { PageHero } from '../../components/layout/pageHero';
import { SectionTitle } from '../../components/layout/sectionTitle';
import { BackToTop } from '../../components/layout/shell/backToTop';
import Footer from '../../components/layout/shell/footer';
import { SplitPane } from '../../components/layout/splitPane';
import { SplitPaneCopy } from '../../components/layout/splitPaneCopy';
import { View } from '../../components/layout/view';
import { ImageGallery } from '../../components/media/imageGalleryOld';
import { VimeoPlayer } from '../../components/socialMedia/vimeoPlayer';
import useAboutUsPage from '../../hooks/staticQueries/aboutUs/useAboutUsPage';
export const CompanyPage = () => {
    const { page, photos } = useAboutUsPage();
    return (<View className="about-us" title="Company">
      <PageHero>
        <ImageGallery images={photos.map((image) => ({
        ticket: image.image[0].ticket,
        caption: image.caption,
    }))}/>
      </PageHero>

      {!!page.video_id && (<SplitPane className="about-us-video" vertical left={<VimeoPlayer id={page.video_id}/>} right={<div className="video-caption">
              <p>
                <strong>{page.video_caption}</strong>
              </p>
            </div>}/>)}

      {!!page.page_top_copy.length &&
        page.page_top_copy.map((copy, i) => (<SplitPaneCopy markdown={copy.markdown} image={{
            ticket: copy.image[0].ticket,
            alt: 'About us image',
        }} key={i}/>))}

      <SectionTitle title={page.team_text.team_header} description={page.team_text.team_copy} imageTicket={page.section_icons.team_icon[0].ticket} button={{ children: 'More on our People', to: '/about-us/people', variant: 'brand-secondary' }}/>

      <SectionTitle title={page.stack_text.stack_header} description={page.stack_text.stack_copy} imageTicket={page.section_icons.stack_icon[0].ticket} button={{
        to: '/about-us/technology',
        children: 'Our Stack',
        variant: 'brand',
    }}/>

      <SectionTitle title={page.product_toolkit.product_toolkit_header} description={page.product_toolkit.product_toolkit_copy} imageTicket={page.section_icons.product_toolkit_icon[0].ticket}/>

      <ProductsWrapper />

      <SectionTitle title={page.brand_guide_text.brand_guide_name} description={page.brand_guide_text.brand_guide_copy} imageTicket={page.brand_guide_text.brand_guide_icon[0].ticket} className="brand-guide" button={{
        to: '/brand-guide',
        children: 'Brand Guide',
        variant: 'brand',
    }}/>

      <Footer />

      <BackToTop />
    </View>);
};
export default CompanyPage;
